import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { APP_IMAGES } from "../../constants/AppImages";

/**
 * Lena Logo Component
 *
 * Modular logo component that replaces DMS Pollus logo throughout the application.
 * Can be used in header, sidebar, and login page.
 *
 * @param {boolean} showLabel - Whether to show the "LENA" text label
 * @param {string} variant - Size variant: 'small', 'medium', 'large'
 * @param {object} sx - Additional Material-UI sx props
 */
export const LenaLogo = ({
    showLabel = true,
    variant = 'medium',
    sx = {},
    ...props
}) => {
    const sizeMap = {
        small: {
            logoWidth: '32px',
            fontSize: '16px',
        },
        medium: {
            logoWidth: '40px',
            fontSize: '20px',
        },
        large: {
            logoWidth: '95px',
            fontSize: '32px',
        },
    };

    const size = sizeMap[variant] || sizeMap.medium;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                cursor: 'pointer',
                ...sx
            }}
            {...props}
        >
            <Box
                component="img"
                src={APP_IMAGES.LOGO}
                alt="Lena Logo"
                sx={{
                    width: size.logoWidth,
                    height: 'auto',
                    objectFit: 'contain',
                }}
            />
            {showLabel && (
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: size.fontSize,
                        color: 'inherit',
                        letterSpacing: '0.5px',
                    }}
                >
                    LENA
                </Typography>
            )}
        </Box>
    );
};

LenaLogo.propTypes = {
    showLabel: PropTypes.bool,
    variant: PropTypes.string,
    sx: PropTypes.object
};

export default LenaLogo;
